import type { HobbyCode } from "./types";

export interface HobbyPresentation {
  emoji: string;
  eyebrow: string;
  detail: string;
  example: string;
  saved: string;
  visualClass: string;
}

export const hobbyPresentation: Record<HobbyCode, HobbyPresentation> = {
  painting: {
    emoji: "🖼️",
    eyebrow: "Смотреть внимательнее",
    detail: "Раз в неделю вы получаете одну картину и разбираетесь, что значат её детали, почему художник выбрал именно эти цвета и что происходило в момент её создания.",
    example: "Какая деталь изменила ваше первое впечатление — и почему?",
    saved: "Картина и ваше собственное наблюдение останутся в личной коллекции.",
    visualClass: "cover-painting"
  },
  letters: {
    emoji: "✉️",
    eyebrow: "Услышать живой голос",
    detail: "Раз в неделю приходит письмо известного человека: кто автор, кому он писал, что происходило вокруг и что эта переписка открывает лучше обычной биографии.",
    example: "Что в письме показывает автора живее биографической справки?",
    saved: "Письмо, контекст и ваша заметка постепенно составят личный архив.",
    visualClass: "cover-letters"
  },
  objects: {
    emoji: "💡",
    eyebrow: "Замечать неочевидное",
    detail: "Раз в неделю вы выбираетесь из привычного взгляда на обычную вещь и узнаёте, какую проблему она решала, кто её придумал и почему знакомая форма появилась не сразу.",
    example: "Какая часть истории этой вещи оказалась самой неожиданной?",
    saved: "История предмета и ваш вывод сохранятся рядом с другими открытиями.",
    visualClass: "cover-objects"
  }
};

